import React from 'react';
import { SectionHeading } from './SectionHeading';
import { VideoCard } from './VideoCard';
import { channel } from '../data/channel';
import type { Video } from '../types/video';
interface LatestVideosProps {
  videos: Video[];
}
export function LatestVideos({
  videos
}: LatestVideosProps) {
  return <section id="latest" aria-labelledby="latest-title" className="scroll-mt-20 py-20 md:py-28" data-id="element-54" data-mp="2x9cwyxm2s42p">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-55" data-mp="2ikzwbnc1lx1v">
        <SectionHeading id="latest-title" title="Свіжі випуски" subtitle="Останні походи Карпатами — від одноденних маршрутів до 60 км за день." link={{
        href: `${channel.url}/videos`,
        label: 'Усі відео на YouTube'
      }} data-id="element-56" data-mp="2ijf444d7aq76" />
        <div className="mt-10 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-57" data-mp="2ek6aczi5usbm">
          {videos.map(video => <VideoCard key={video.id} video={video} data-id="element-58" data-mp="1zogvdlbe7fge" />)}
        </div>
      </div>
    </section>;
}